Postlogin = (function (my) {
    my.LicensesReport = {};
    const me = my.LicensesReport;
    me.reportTable = $('#license-report-table');
    me.exportUrl = me.reportTable.data('export-url');

    me.init = function () {
        me.initEvents();
    };

    me.getLicenseReport = function () {
        me.reportTable.bootstrapTable('destroy');
        me.reportTable.bootstrapTable('showLoading');
        me.reportTable.bootstrapTable(me.tableOptions);
    };

    me.initEvents = function () {
        $('#license-search-date')
            .on('change', () => {
                const value = $('#license-search-date option:selected').val();
                if (value === 'custom') {
                    $('#licenses-start-date').val(moment().subtract(14, 'days').format('L'));
                    $('#licenses-end-date').val(moment().format('L'));
                    $('.license-dates .date-container.hide').removeClass('hide');
                } else {
                    $('.license-dates .date-container').addClass('hide');
                    me.getLicenseReport();
                }
            })
            .trigger('change');

        const currentDate = new Date(new Date().setHours(23, 59, 59));

        const dateOptions = {
            restrictions: {
                maxDate: currentDate,
            },
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
        };

        const licenseStartDate = new tempusDominus.TempusDominus(document.getElementById('licenses-start-date'), {
            ...dateOptions,
            container: document.getElementById('license-start-date-container'),
        });

        const licenseEndDate = new tempusDominus.TempusDominus(document.getElementById('licenses-end-date'), {
            ...dateOptions,
            container: document.getElementById('license-end-date-container'),
        });

        licenseStartDate.subscribe(tempusDominus.Namespace.events.change, (e) => {
            licenseEndDate.updateOptions({
                restrictions: {
                    minDate: e.date,
                },
            });

            me.getLicenseReport();
        });

        licenseEndDate.subscribe(tempusDominus.Namespace.events.change, (e) => {
            licenseStartDate.updateOptions({
                restrictions: {
                    maxDate: e.date,
                },
            });

            me.getLicenseReport();
        });

        $('#licenses-export').on('click', (event) => {
            event.preventDefault();
            me.exportLicenses();
        });
    };

    me.exportLicenses = function () {
        const opts = me.reportTable.bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map(me.reportTable.bootstrapTable('getVisibleColumns'), (col) => col.field),
            page: 1,
            pageSize: 9999999,
            sortName: opts.sortName,
            sortOrder: opts.sortOrder,
            browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.getReportParams = function (params) {
        const searchParams = _.extend({}, params);
        searchParams.date = $('#license-search-date option:selected').val();
        searchParams.date_range_from = $('#licenses-start-date').val();
        searchParams.date_range_to = $('#licenses-end-date').val();

        return searchParams;
    };

    // this works for now, but namespacing issues might be present -
    // better to use Jr.reportsDataTable.options as extension versus reports baseTable.
    me.tableOptions = _.extend({}, Jr.dataTable.options, {
        idField: 'license_id',
        pagination: true,
        sidePagination: 'server',
        url: '/reports/licenseReport/',
        toolbar: '#licenses-export-toolbar',
        queryParamsType: '',
        queryParams(params) {
            const searchParams = _.extend({}, params);
            searchParams.date = $('#license-search-date option:selected').val();
            searchParams.date_range_from = $('#licenses-start-date').val();
            searchParams.date_range_to = $('#licenses-end-date').val();

            return searchParams;
        },
        columns: [
            {
                title: 'License Name',
                field: 'license_name',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Expiration Date',
                field: 'expiration_date',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
            {
                title: 'Account Limit',
                field: 'user_account_limit',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Total Users',
                field: 'users',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Total Admins',
                field: 'admins',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Time On Site',
                field: 'time_on_site',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Site Visits',
                field: 'site_visits',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assessments Completed',
                field: 'completed_assessments',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Lessons Completed',
                field: 'completed_lessons',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Career Journals',
                field: 'career_journals',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Careers Viewed',
                field: 'careers_viewed',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Created',
                field: 'date_created',
                align: 'center',
                valign: 'middle',
                hidden: true,
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
            {
                title: 'Activation',
                field: 'activation_date',
                align: 'center',
                valign: 'middle',
                hidden: true,
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
        ],
    });

    return my;
}(Postlogin || {}));
